import jwtDecode from 'jwt-decode';

const getUserDataFromToken = (token) => {
  if (!token) return null;

  try {
    return jwtDecode(token);
  } catch (err) {
    return null;
  }
};

export default getUserDataFromToken;
